<template>
  <div class="game-container">
    <mp-question v-for="(q, i) in questions" :key="'mp-quesition_' + i" v-show="q.isOpen" :config="q"> </mp-question>
    <div class="pagination-container">
      <div>{{ mainQuestionText }} nr:</div>
      <ul class="pagination pagination-circular">
        <li v-for="(q, i) in questions" :key="'question_' + i">
          <a
            @click="toggleQuestion(i)"
            :key="'question_' + i"
            :class="[{ good: q.isCorrect == 1 }, { bad: q.isCorrect == 2 }, { curr: isOpen(i) }]"
          >
            {{ i + 1 }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import MpQuestion from './MpMillionairesQuestion/MpMillionairesQuestion';
export default {
  name: 'mp-millionaires',
  components: { MpQuestion },
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      questions: {},
      mainQuestionText: this.startGameConfig.mainQuestionText || 'Plansza',
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    giveMeImagePlease(p) {
      let path = require('path');
      let imgPath = p;
      imgPath = imgPath.replace('static/', '');
      imgPath = path.normalize(imgPath);
      return imgPath;
    },
    newGame() {
      this.initData = this.startGameConfig;
      var data = false;
      if (this.startGameConfig.shuffleVariant !== true)
        data = this.startGameConfig.shuffle ? this.shuffle(this.initData.sample) : this.initData.sample;
      else {
        let ix = Math.round(Math.random() * (this.initData.sample.length - 1));
        data = this.startGameConfig.shuffle ? this.shuffle(this.initData.sample[ix]) : this.initData.sample[ix];
      }
      let items = Object.assign({}, data);
      var i = -1;
      var self = this;
      this.questions = _.map(items, (item) => {
        i++;
        let g = item.ans[item.cor];
        item.ans = item.shuffle ? this.shuffle(item.ans) : item.ans;
        item.cor = item.ans.indexOf(g);
        return {
          w: self.startGameConfig.width,
          ans: item.ans,
          txt: item.txt,
          src: require(`__staticDir/${this.$store.getters.multibookType}/${this.giveMeImagePlease(item.src)}`),
          style: self.startGameConfig.style,
          cssStyle: item.cssStyle,
          correct: item.cor,
          val: null,
          checks: false,
          isCorrect: false,
          isOpen: false,
          id: 'q-' + i,
        };
      });
      this.questions[0].isOpen = true;
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    isOpen(i) {
      return this.questions[i].isOpen;
    },
    closeAllQuestions() {
      this.questions.forEach(function(item, i) {
        item.isOpen = false;
      });
    },
    openQuestion(i) {
      this.questions[i].isOpen = true;
    },
    toggleQuestion(i) {
      this.closeAllQuestions();
      this.openQuestion(i);
      this.resetCheckStatus();
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      this.$forceUpdate();
      var isCorrect = true;
      this.questions.forEach(function(a, i) {
        if (a.val != null) a.checks = true;
        if (!a.checks || a.val === null) a.isCorrect = 0;
        else {
          if (a.val === a.correct) a.isCorrect = 1;
          else a.isCorrect = 2;
        }
        if (a.isCorrect != 1) {
          isCorrect = false;
        }
      });
      this.$forceUpdate();
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function(newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: white;
}
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.pagination {
  margin-top: 100px;
}

.pagination-circular li {
  margin: 0 20px;
}

.pagination-circular a.good {
  border: 1px solid hsla(150, 75%, 50%, 1);
  background-color: hsla(150, 75%, 50%, 1) !important;
}

.pagination-circular a.bad {
  border: 1px solid hsla(360, 75%, 50%, 1);
  background-color: hsla(360, 75%, 50%, 1) !important;
}

.pagination-circular a.curr {
  border: 2px solid #1779ba;
  border-radius: 5000px;
  padding: 0.285em 0.8em;
  font-size: 35px;
  background: #1779ba;
  // color: #fefefe;
  cursor: default;
}

.pagination-circular a {
  border-radius: 5000px;
  padding: 0.285em 0.8em;
  border: 1px solid #1779ba;
  font-size: 35px;
  text-decoration: none;
}

.pagination-circular li:hover a {
  background: #1779ba;
  color: #fefefe;
}

.pagination-circular li a {
  transition: background 0.15s ease-in, color 0.15s ease-in;
}
</style>
